import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../../../app.service';
import { PreferencesService } from '../../preferences.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AppUris } from '../../../../entities';
import { CryptoService } from '../../../../services/crypto.service';

@Component({
  selector: 'app-account-view',
  templateUrl: './account-view.component.html',
  styleUrls: ['./account-view.component.scss']
})
export class AccountViewComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  username: string;
  email: string;
  loadingPreferences: boolean = true;
  savingUpdatePassword: boolean = false;

  constructor(
    private readonly _app: AppService,
    private readonly _pref: PreferencesService,
    private readonly _notify: NotificationsService,
    private _crypto: CryptoService  ) { }

  ngOnInit() {
    this._app.setPageTitle('Preferences | Account');
    this.loadAllData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => { if (!s.closed) s.unsubscribe() });
  }

  loadAllData() {
    let email = this._pref.GetEmail();
    let username = this._pref.getUsername();

    this.subscriptions.push(forkJoin([email, username]).subscribe(results => {
      this.email = results[0];
      this.username = results[1];
      this.loadingPreferences = false;
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to load your preferences. Please contact TrackTreads support. ');
    }));
  }

  updateUsername(username: string) {
    this._pref.updateUsername(encodeURIComponent(this._crypto.encrypt(username))).subscribe(r => {
      if (r.m_Item1) {
        this._app.loadUsername();
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.error('Not Allowed', r.m_Item2);
        console.error(r.m_Item2);
      }
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to update your username. Please contact TrackTreads support. ');
    });
  }

  updateEmail(email: string) {
    this._pref.updateEmail(encodeURIComponent(this._crypto.encrypt(email))).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.error('Not Allowed', r.m_Item2);
        console.error(r.m_Item2);
      }
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to update your email. Please contact TrackTreads support. ');
    });
  }

  updatePasswordClicked(password1: string, password2: string) {
    if (this.savingUpdatePassword) return;
    if (password1 != password2) {
      this._notify.alert('Check Password', 'You must enter the same password in both fields. ');
      return;
    }
    if (password1.length < 4) {
      this._notify.alert('Check Password', 'Your password must be at least 4 characters long. ');
      return;
    }
    this.savingUpdatePassword = true;
    this._pref.updatePassword(encodeURIComponent(this._crypto.encrypt(password1))).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.error('Not Allowed', r.m_Item2);
        console.error(r.m_Item2);
      }
      this.savingUpdatePassword = false;
    }, error => {
      console.error(error);
      this._notify.error('Error', 'Unable to update your password. Please contact TrackTreads support. ');
      this.savingUpdatePassword = false;
    });
  }
}
